<template>
    <div class="plist-filter">
        <div class="container">
            <!-- 子类列表 -->
            <div class="filter-category">
                <slot name="category"></slot>
            </div>
            <!-- 品牌选择 -->
            <div class="filter-brand">
                <slot name="brand"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.plist-filter {
    padding: 20px 0;
    background-color: #fff;
}
.filter-category {
    margin-bottom: 10px;
}
</style>